export default {
	data() {
		return {
			ac_type:'',
			
			levelType: 0,
			preUrl: "",
			delAllUrl: "",
			delUrl: "",
			addUrl: "",
			editStatusUrl: "",
			page: {
				current: 1,
				sizes: [10, 20, 50, 100],
				size: 10,
				total: 0
			},
			search: '',
			toid:0,
			prop: 'create_time',
			sort: 'descending',
			isUpdateNum: false,
			tableHeight:0,
			observer:null,
			multipleSelection: [],
			pickerOptions: {
				shortcuts: [{
					text: this.$t('system.lastWeek'),
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: this.$t('system.lastMonth'),
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: this.$t('system.lastThreeMonths'),
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit('pick', [start, end]);
					}
				}]
			},
		}
	},
	filters: {
		numToString(value) {
			return value.toString();
		}
	},
	created() {
		if (typeof this.$route.params.type != 'undefined') {
			if(this.$route.params.type=='toType'){
				this.type = this.$route.params.value
			}
		}
		if (typeof this.$route.params.toid != 'undefined') {
			this.toid = this.$route.params.toid
		}
		if (typeof this.$route.params.search != 'undefined') {
			this.from = this.$route.params.search
			this.search = this.$route.params.search
		}
		if (typeof this.$route.params.totalToOrder != 'undefined') {
			this.from.agent_id = this.$route.params.totalToOrder.agent_id
			this.from.name = this.$route.params.totalToOrder.name
			this.from.username = this.$route.params.totalToOrder.username
			this.search = this.from
		}
		
		
		if (typeof this.$route.params.checkUserAccount != 'undefined') {
			this.from.name = this.$route.params.checkUserAccount.name
			this.search = this.from
		}
		
		if (localStorage.getItem('domainDetail')) {
			let domainDetail = JSON.parse(localStorage.getItem('domainDetail'));
			this.from.name = domainDetail.domain_name
			this.from.id = domainDetail.id
			this.search = this.from
		}
		
		if (localStorage.getItem('commonDetailPage')) {
			let commonDetailPage = JSON.parse(localStorage.getItem('commonDetailPage'));
			this.from.id = commonDetailPage.id
			this.from.name = commonDetailPage.name
			this.from.type = commonDetailPage.type
			this.search = this.from
		}
		this.getList()
	},
	mounted() {
		this.$nextTick(() => {
			this.observer = new ResizeObserver(entries => {
			  for (let entry of entries) {
				// 處理高度变化後的逻辑
				this.getSearchDivHeight();
			  }
			});
			if (this.$refs.searchDiv) {
			  this.observer.observe(this.$refs.searchDiv);
			} else {
			  //console.log('searchDiv 參考未找到');
			}
		  });
	},
	beforeDestroy() {
	  if (this.observer) {
	    this.observer.disconnect();
	  }
	},
	computed: {
		computedLeft() {
			if(this.layout.isCollapse){
				if(this.layout.is_phone){
					return "0px";
				}else{
					return "64px";
				}
			}else{
				return "200px";
			}
		},
		// 选中记录id組成的數組
		ids() {
			return this.multipleSelection.map(item => {
				return item.id
			})
		}
	},
	methods: {
		getSearchDivHeight() {
		  if (this.$refs.searchDiv) {
			  let searchH = this.$refs.searchDiv.offsetHeight;
				this.tableHeight = window.innerHeight - searchH - 200;
		  }
		},
		// 搜索
		searchEvent(e = false) {
			// 簡單搜索
			this.page.current = 1;
			if (typeof e === 'string') {
				this.search = e;
				this.getList()
				return
			}
			this.search = this.from
			this.getList()
			
		},
		showExpress(data){
			this.layout.showExpressModel(data);
		},
		// 多选
		handleSelectionChange(val) {
			this.multipleSelection = val;
			console.log(this.multipleSelection);
		},
		handleSizeChange(val) {
			this.page.size = val
			//console.log(`每页 ${val} 条`);
			this.getList()
		},
		sortChange(column){
			this.prop = column.prop
			this.sort = column.order
			this.getList()
		},
		handleCurrentChange(val) {
			this.page.current = val
			this.getList()
			//console.log(`當前页: ${val}`);
		},
		// 處理列表结果
		getListResult(data) {

		},

		// 获取請求列表分页url
		getListUrl() {
			return `/admin/${this.preUrl}`
		},
		handleClick(tab, event) {
			this.search = this.from
			//this.search = ''
			this.getList()
		},

		//获取列表
		getList() {
			if (this.preUrl == '') return
			
			this.layout.loading = true;
			this.axios.post(this.getListUrl(), {
				page: this.page.current,
				limit: this.page.size,
				search: this.search,
				prop: this.prop,
				type: this.type,
				ac_type: this.ac_type,
				toid:this.toid,
				sort: this.sort == 'ascending' ? 'asc' : 'desc'
			}, {
				token: true,
				loading: true
			}).then(res => {
				let all = res.data
				
				let list = all.data.list;
				
				this.page.total = list.total
				this.toid = 0
				this.tableData = list.list
				this.getListResult(list)
				this.getSearchDivHeight();
				this.layout.loading = false;
			}).catch(err => {
				// 失敗
				console.log(err);
				this.layout.loading = false;
			})
		},
		// 添加/修改url
		changeStatusUrl() {
			return `/admin/${this.editStatusUrl}`
		},
		// 修改狀態
		changeStatus(item,  type = 'status', showAlert = true, is_update = false) {
			let status = 0;
			// 根据類型判断狀態
			status = item[type] === 1 ? 0 : 1;
			
			// 状态判断
			let msg = status === 1 ? this.$t('status.enable') : this.$t('status.disable');
			
			this.layout.loading = false;
			this.axios.post(this.changeStatusUrl(), {
			 id: item.id,
			 status: status,
			 type: type,
			 page_type: this.type
			}, {
			 token: true
			}).then(res => {
			 let all = res.data;
			 if (all.code == 1) {
			  item[type] = status
			  if (showAlert) {
			   this.$message({
				message: msg,
				type: 'success'
			   });
			  }
			  if (is_update) {
			   this.layout.getPageNum();
			  }
		 
			 }
			 this.createModel = false;
			}).catch(err => {
			 this.createModel = false;
			 if (showAlert) {
			  this.$message.error(this.$t('system.openFailed'));
			 }
			});
		   },

		// 添加/修改url
		addOrEditUrl() {
			return `/admin/${this.addUrl}`
		},
		copyText(text) {
		  
			//console.log(111)
		  navigator.clipboard.writeText(text)
			.then(() => {
			  this.$message.success(this.$t('cdn.copy_ok'));
			})
			.catch(() => {
			  this.$message.error(this.$t('cdn.copy_fail'));
			});
		},
		//添加/修改
		addOrEdit(data, is_update = false, showAlert = true, showLoading = true) {
			if (showLoading) {
				this.layout.loading = true;  // 控制加載层的顯示
			}

			this.axios.post(this.addOrEditUrl(), data, {
				token: true
			}).then(res => {
				let all = res.data;
				if (all.code == 1) {
					if (showAlert) {
						this.$message({
							message: all.msg,
							type: 'success'
						}); // 控制是否顯示成功提示
					}
					this.createModel = false;
					if (is_update) {
						this.layout.getPageNum();
					}
				}
				this.getList();
				this.submitLoading = false;
				if (showLoading) {
					this.layout.loading = false;  // 控制加載层的隐藏
				}
			}).catch(err => {
				this.submitLoading = false;
				if (showLoading) {
					this.layout.loading = false;  // 控制加載层的隐藏
				}
			});
		},


		// 批量删除url
		deleteAllUrl() {
			return `/admin/${this.delAllUrl}`
		},
		// 批量删除
		deleteAll() {
			if (this.ids.length === 0) {
				return this.$message({
					message: this.$t('system.delData'),
					type: 'error'
				});
			}
			this.$confirm(this.$t('system.yesOrNoDel'), this.$t('system.prompt'), {
				confirmButtonText: this.$t('system.delete'),
				cancelButtonText: this.$t('system.cancel'),
				type: 'warning'
			}).then(() => {
				this.layout.loading = true;
				let url = this.deleteAllUrl()
				this.axios.post(url, {
					ids: this.ids,
					type: this.type
				}, {
					token: true,
					loading: true
				}).then(res => {

					this.multipleSelection = []
					this.$message({
						message: this.$t('system.deleteSuccess'),
						type: 'success'
					});
					console.log(1);
					this.getList()

					this.layout.loading = false;
				}).catch(err => {
					this.layout.loading = false;
				})
			})
		},
		// 删除url
		deleteUrl() {
			return `/admin/${this.delUrl}`
		},
		// 删除單个
		deleteItem(item) {
			this.$confirm(this.$t('system.yesOrNoDel'), this.$t('system.prompt'), {
				confirmButtonText: this.$t('system.delete'),
				cancelButtonText: this.$t('system.cancel'),
				type: 'warning'
			}).then(() => {
				this.layout.loading = true;
				this.axios.post(this.deleteUrl(), {
					id: item.id,
					type: this.type
				}, {
					token: true
				}).then(res => {
					if(res.code == 1){
						this.$message({
							message: this.$t('system.deleteSuccess'),
							type: 'success'
						});
					}
					this.getList()
					this.layout.loading = false;
				}).catch(err => {
					this.layout.loading = false;
				})
			})
		},
	}
}
